import {
    Flex,
    TabbedNavigation,
    TabbedNavigationItem,
    Tooltip,
} from "@amzn/storm-ui";
import type { ReactElement } from "react";
import styled from "styled-components";

import { TopNavBarTabs } from "../../../types/navigation";

interface Tab {
    label: TopNavBarTabs;
    enabled: boolean;
    icon?: ReactElement;
    tag?: ReactElement;
    tooltipText?: string | undefined;
    shown: boolean;
}

const StyledTabNavItem = styled.div<{ disabled: boolean }>`
    padding-right: 20px;
    ${(props) =>
        props.disabled &&
        `&:hover{
            li::after {
                content: none;
            }
        }`}
`;

export const TabbedNav: React.FunctionComponent<{
    handleOnTabChange: (tab: TopNavBarTabs) => void;
    activeTab: TopNavBarTabs;
}> = ({ handleOnTabChange, activeTab }) => {
    const tabs: Tab[] = [
        { label: TopNavBarTabs.ALL_INSIGHTS, enabled: true, shown: true },
        {
            label: TopNavBarTabs.YOUR_INSIGHT_DECKS,
            enabled: true,
            shown: true,
        },
    ];

    return (
        <TabbedNavigation>
            {tabs
                .filter((t) => t.shown)
                .map(({ label, icon, tag, enabled, tooltipText }) => {
                    const NavItem: React.FC = () => {
                        return (
                            <TabbedNavigationItem
                                active={activeTab === label}
                                label={
                                    <Flex alignItems="center">
                                        {icon}
                                        {label}
                                        {tag}
                                    </Flex>
                                }
                                disabled={!enabled}
                                onClick={() =>
                                    enabled && handleOnTabChange(label)
                                }
                                style={{
                                    pointerEvents: enabled ? "auto" : "none",
                                    alignItems: "center",
                                }}
                                data-testid={label}
                            />
                        );
                    };

                    return (
                        <StyledTabNavItem disabled={!enabled} key={label}>
                            {tooltipText ? (
                                <Tooltip
                                    key={label}
                                    message={tooltipText}
                                    trigger={
                                        <div>
                                            <NavItem />
                                        </div>
                                    }
                                    position="bottom"
                                    withCloseButton={false}
                                />
                            ) : (
                                <NavItem />
                            )}
                        </StyledTabNavItem>
                    );
                })}
        </TabbedNavigation>
    );
};
